import { InsurancePlanTypeV2 } from '@truepill/tpos-types'

const snakeToPascalCase = (value: string): string =>
  value
    .split('_')
    .filter(Boolean)
    .map(word => word[0].toUpperCase() + word.slice(1))
    .join('')

const isValidKey = (key: string): key is keyof typeof InsurancePlanTypeV2 => key in InsurancePlanTypeV2

const mapCoreCoverageTypeInsurance = (coverageType: string | undefined): InsurancePlanTypeV2 | undefined => {
  if (!coverageType) return undefined

  const formattedCoverage = snakeToPascalCase(coverageType)

  if (isValidKey(formattedCoverage)) {
    return InsurancePlanTypeV2[formattedCoverage]
  }

  return undefined
}

export default mapCoreCoverageTypeInsurance
